import { RouteLocationNormalized } from 'vue-router'

const vueRouterManagedTagAttr = 'data-vue-router-controlled'

export function removeRouterManagedMetaTags() {
  ;[...document.querySelectorAll(`[${vueRouterManagedTagAttr}]`)].forEach(
    el => {
      el.parentElement?.removeChild(el)
    }
  )
}

export function addRouterManagedMetaTag(
  name: string,
  fallback: string,
  route: RouteLocationNormalized
) {
  const val = route.meta[name] || fallback
  const metaTag: HTMLElement = document.createElement('meta')

  metaTag.setAttribute(vueRouterManagedTagAttr, '')
  metaTag.setAttribute('name', name)
  metaTag.setAttribute('content', val as string)

  document.head.appendChild(metaTag)
}
